import React from 'react';
import { Shield, MessageSquare, Mail } from 'lucide-react';
export function PrivacyStatement() {
  return <div className="min-h-screen bg-white pt-40 lg:pt-52 pb-20" data-id="element-1511">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1512">
        {/* Page Header */}
        <div className="mb-12" data-id="element-1513">
          <div className="flex items-center justify-center mb-4" data-id="element-1514">
            <Shield className="w-12 h-12 text-brand-purple-600 mr-4" data-id="element-1515" />
            <h1 className="text-4xl font-bold text-gray-900" data-id="element-1516">
              Privacy Statement
            </h1>
          </div>
        </div>

        {/* General Privacy Statement */}
        <div className="prose prose-lg max-w-none mb-12" data-id="element-1517">
          <p className="text-base leading-relaxed text-gray-700" data-id="element-1518">
            By registering with Desert Sage Seminars, you will create an account
            by which we may provide you with quality On-Demand real estate
            license renewal classes. Your information will be kept confidential
            and not shared with any other party. The Arizona Department of Real
            Estate requires that we confirm your information and that you are
            the person taking the classes. We will ask you to affirm that each
            time you begin a class. Impersonating a real estate licensee is
            subject to forfeiture of the real estate license for either or both
            parties. Payments you make for our classes are made through a 3rd
            party merchant account secured by our site, and they do not share
            your credit card information with us or any other party.
          </p>

          <p className="text-base leading-relaxed text-gray-700 mt-6" data-id="element-1519">
            All payment information collected is done so under SSL – a standard
            internet security measure. Any data that we store about you is kept
            behind a secure firewall in our database and is not accessible to
            the public in any way. Any requests by an outside party for
            informaton about you or your account will be denied except for any
            request from the Arizona Department of Real Estate, or any other
            regulatory agency empowered to investigate your real estate
            activity.
          </p>
        </div>

        {/* Terms Section */}
        <div id="terms" className="border-t-2 border-gray-200 pt-12 mb-12" data-id="element-1520">
          <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-1521">
            Terms of Service
          </h2>

          <div className="space-y-6" data-id="element-1522">
            <p className="text-base leading-relaxed text-gray-700" data-id="element-1523">
              Under no circumstances will Desert Sage Seminars sell or share
              your name, mobile telephone number, or other personal information
              with third-parties or affiliates for marketing or promotional
              purposes.
            </p>

            <p className="text-base leading-relaxed text-gray-700" data-id="element-1524">
              Under no circumstances will Desert Sage Seminars purchase or use
              your name and mobile telephone number collected from third
              parties.
            </p>
          </div>
        </div>
      </div>
    </div>;
}